import AxiosService from "./axiosServices";
const axiosService = new AxiosService();
class Service {
  Login = async (body) => {
    return axiosService.Post(`api/cam/login/`, body);
  };

  userLogout = () => {
    return axiosService.Get(`api/cam/logout/`);
  };
  allUserLogout = (data) => {
    return axiosService.Post(`api/cam/logout-of-all-devices/`, data);
  };

  forgotPasswordLink = (userName, passwordResetLink) => {
    const data = {
      body: { username: userName, password_reset_link: passwordResetLink },
    };
    return axiosService.Post(`api/cam/send-reset-password-link/`, data);
  };

  forgotPassword = (userName, newPassword, token) => {
    const data = {
      body: { password: newPassword, hash_key: token },
    };
    return axiosService.Post(`api/cam/update-password/`, data);
  };

  saveUserSignature(filePath) {
    const data = {
      body: {
        signature_b64: filePath,
      },
    };
    return axiosService.Post(`api/cam/upload-e-signature/`, data);
  }
  getUserSignature() {
    return axiosService.Get(`api/cam/get-uploaded-e-signature/`);
  }

  submitOtp(otp) {
    const data = {
      body: {
        otp: otp,
      },
    };
    return axiosService.Post(`api/cam/verify-otp/`, data);
  }
  resendOtp(userName) {
    const data = {
      body: { username: userName },
    };
    return axiosService.Post(`api/cam/resend-otp/`, data);
  }
  sendIP(ip, id) {
    const data = {
      body: { user_ip: ip, user_id: id },
    };
    return axiosService.Post(`api/cam/store-user-ip/`, data);
  }
  checkLinkStatus = (hash_key) => {
    const params = {
      hash_key: hash_key,
    };
    return axiosService.Get(`api/cam/check-password-reset-url/`, {
      params: params,
    });
  };
}

export default Service;
